import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import { message } from 'antd'

import CityRoutesTable from './partials/CityRoutesTable'
import NewCityRouteModal from './partials/NewCityRouteModal'
import ImportCityRoutesModal from './partials/ImportCityRoutesModal'
import ListTopBar from '../../components/ListTopBar'

import { getCityRoutes } from './services'
import { storeExportToken } from '../ExportTokens/services'
import { getUrl } from '../../services/springApi'
import { handleError } from '../../helpers'

export default function CityRoutesList() {
	const { user } = useSelector(state => state.auth)
	const [cityRoutes, setCityRoutes] = useState(null)
	const [filterType, setFilterType] = useState('city')
	const [filterValue, setFilterValue] = useState('')
	const [showCreateModal, setShowCreateModal] = useState(false)
	const [showImportModal, setShowImportModal] = useState(false)

	useEffect(() => {
		!cityRoutes && getCityRoutes({
			[`filter[${filterType}]`]: filterValue,
			include: 'cityRouteRates',
			sort: 'city',
		})
			.then(res => setCityRoutes(res.data.data))
			.catch(error => handleError(error))
	}, [ cityRoutes, filterType, filterValue ])

	const onExport = () => {
		const token = Date.now() + Math.floor(1000 + Math.random() * 9000)

		storeExportToken({ user_id: user.id, type: 'Exportar Entregas', token })
			.then(() => {
				message.info('Descarga en iniciada correctamente')
				window.open(`${getUrl()}/exports/city_routes/${token}`)
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<ListTopBar 
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				title="Listado de Rutas de Entrega"
				subtitle="Detalle de rutas de entrega por ciudad"
				reload={() => setCityRoutes(null)}
				options={[
					{ value: 'city', label: 'Buscar por ciudad' },
					{ value: 'region', label: 'Buscar por regional' },
					{ value: 'code', label: 'Buscar por código de ruta' },
				]}
				ctaText="Agregar Ruta"
				handleCtaClick={() => setShowCreateModal(true)}
				secundaryCtaText="Importar Masivamente"
				handleSecundaryCtaClick={() => setShowImportModal(true)}
				tertiaryCtaText="Exportar Listado"
				handleTertiaryCtaClick={onExport}
			/>
			<Card>
				<CardBody>
					<CityRoutesTable 
						cityRoutes={cityRoutes}
						reload={() => setCityRoutes(null)}
					/>
				</CardBody>
			</Card>

			<NewCityRouteModal 
				visible={showCreateModal}
				onClose={() => setShowCreateModal(false)}
				reload={() => setCityRoutes(null)}
			/>

			{ showImportModal && (
				<ImportCityRoutesModal
					visible
					onClose={() => setShowImportModal(false)}
					reload={() => setCityRoutes(null)}
				/>
			)}
		</React.Fragment>
	)
}